var _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMongoDb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 14,
    viewBox: "0 0 7 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.4577 13.9999L3.0822 13.8754C3.0822 13.8754 3.1322 11.9754 2.4447 11.8419C1.9947 11.3179 2.5112 -10.5286 4.1562 11.7674C3.84409 11.9257 3.60528 12.1986 3.4897 12.5289C3.42776 13.0168 3.41703 13.5098 3.4577 13.9999Z",
    fill: "url(#paint0_linear_1467_233)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.66046 12.1646C4.66025 11.412 5.42591 10.3911 5.86846 9.22056C6.31101 8.05003 6.41226 6.77793 6.16046 5.55212C5.42546 2.30962 3.68496 1.24362 3.49746 0.836621C3.33569 0.583186 3.19761 0.315388 3.08496 0.0366211L3.22346 9.07112C3.22346 9.07112 2.93646 11.8321 3.66046 12.1646Z",
    fill: "url(#paint1_linear_1467_233)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.89089 12.2845C2.89089 12.2845 -0.169608 10.2 0.00739175 6.5125C0.023903 5.40082 0.278794 4.30563 0.754848 3.30091C1.2309 2.29618 1.91703 1.40532 2.76689 0.6885C2.86621 0.604123 2.94511 0.498338 2.99768 0.37909C3.05024 0.259843 3.0751 0.130234 3.07039 0C3.26089 0.41 3.22989 6.1215 3.24989 6.7895C3.32739 9.388 3.10539 11.794 2.89089 12.2845Z",
    fill: "url(#paint2_linear_1467_233)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1467_233",
    x1: 0.933526,
    y1: 7.12605,
    x2: 5.24936,
    y2: 8.59061,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.231,
    stopColor: "#999875"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.563,
    stopColor: "#9B9977"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.683,
    stopColor: "#A09F7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.768,
    stopColor: "#A9A889"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.837,
    stopColor: "#B7B69A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.896,
    stopColor: "#C9C7B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.948,
    stopColor: "#DEDDCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994,
    stopColor: "#F8F6EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBF9EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1467_233",
    x1: 2.51594,
    y1: -0.0279359,
    x2: 4.42395,
    y2: 11.8865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48A547"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F9143"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1467_233",
    x1: -0.255872,
    y1: 6.87751,
    x2: 4.86444,
    y2: 5.16272,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#41A247"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.352,
    stopColor: "#4BA74B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.956,
    stopColor: "#67B554"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#69B655"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMongoDb);
export default __webpack_public_path__ + "static/media/MongoDB.8fb9acdec1ec5dbe0db72e725fe090e6.svg";
export { ForwardRef as ReactComponent };